import { css } from 'styled-components';

export const errorPageBackgroundStyles = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #0001fe;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-blend-mode: normal, multiply;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000; // Should be above everything and not from the theme
`;
